export default __webpack_public_path__ + "static/media/CNo.91-2.4a5f882a.jpg";